import {request} from '@umijs/max';
import BASEURLCONFIG from "../../../config/BASEURLCONFIG";
import { getStoredRegCode } from '@/util/regCode';

export async function findCanOrderApp(params: any) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/findCanOrderApp', {
    params,
  });
}

export async function findApplicationVersionByAppId(params: any) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/findApplicationVersionByAppId', {
    params,
  });
}

export async function findProductByBizType(params: any) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/findProductByBizType', {
    params,
  });
}

export async function submitOrder(params: any) {
  return request('/api/pay/submitOrder', {
    method: 'POST',
    data: params,
  });
}

export async function payOrder(params: any) {
  return request('/api/pay/payOrder', {
    method: 'POST',
    data: params,
  });
}

export async function getEnterpriseProfileOrderInfo(params: any) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL+'/api/v2/perEnterprise/getEnterpriseProfileOrderInfo', {
    params,
  });
}


export async function getOrder(params: any) {
  return request('/api/pay/getOrder', {
    params,
  });
}

export async function getEnterpriseProfileEnvInfo(params: any) {
  return request('/api/v2/perEnterprise/getEnterpriseProfileEnvInfo', {
    params,
  });
}

export async function updateEnterpriseName(params:any) {
  return request('/api/v2/perEnterprise/updateEnterpriseName', {
    method: 'POST',
    data: params,
  });
}


export async function createEnv(params: any) {
  return request('/api/pay/createEnv', {
    method: 'POST',
    data: params,
  });
}

export async function createEnvFromPlatform(params: any) {
  const regCode = params?.regCode || getStoredRegCode();
  const data = {
    ...params,
    ...(regCode ? {regCode} : {}),
  };
  console.log('createEnvFromPlatform request data', data);
  return request(BASEURLCONFIG.ISWAN_BASE_URL+'/api/v2/createEnvFromPlatform', {
    method: 'POST',
    data,
  });
}
